class RichRelevancePlacementCallbackController {
    constructor(richRelevanceService, $window) {
        if ($window.RR && $window.RR.jsonCallback) {
            $window.RR.jsonCallback = function () {
                if ($window.RR.data.JSON.placements && $window.RR.data.JSON.placements.length > 0) {
                    richRelevanceService.onPlacementsReceived($window.RR.data.JSON.placements);
                }
            };
        }
    }
}

const richRelevancePlacementCallbackComponentDefinition = {
    controller: ['RichRelevanceService', '$window', RichRelevancePlacementCallbackController],
};

module.exports = {
    RichRelevancePlacementCallbackController,
    richRelevancePlacementCallbackComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/rr-placement-callback.component.js